import { css } from "@emotion/react";

import theme from "../../styles/theme";

export const checkbox = css`
  margin-left: ${theme.spacing(3)}px;
`;

export const error = css`
  display: block;
  margin-top: 3px;
`;
